module.exports = __webpack_public_path__ + "static/media/polytech_sorbonne.06c59a64.jpg";